import { useCallback, useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { useGetIsPartnerVehicle } from '~/context/vdp/VehicleContext';

function useShowPartnerModal(): (onContinue: () => void) => () => void {
  const { setPartnerModalOpen } = useContext(ModalContext);
  const isPartnerVehicle = useGetIsPartnerVehicle();

  return useCallback(
    (onContinue: () => void) => () => {
      if (!isPartnerVehicle) return onContinue();

      setPartnerModalOpen(true, {
        onContinue: () => {
          setPartnerModalOpen(false);
          onContinue();
        }
      });
    },
    [isPartnerVehicle, setPartnerModalOpen]
  );
}

export default useShowPartnerModal;
